import neighborhoodGolf from '../img/neighborhood/neighborhood_golf.jpg';
import neighborhoodWaterfront from '../img/neighborhood/waterfront.png';
import neighborhoodFoodHall from '../img/neighborhood/food_hall_bar.jpg';
import neighborhoodCostco from '../img/neighborhood/neighborhood_costco.jpeg';
import neighborhoodFerry from '../img/neighborhood/ferry.png'
import tearDropMemorial from '../img/neighborhood/tear_drop_memorial.png'
import lightrail from '../img/neighborhood/lightrail.png'
import shuttleBus from '../img/neighborhood/path.jpg'

export const neighborhoodHighlights = [
  {
    title: "Upcoming Ferry",
    content: ["The upcoming ferry will provide easy access to NYC without the hustle and bustle of the morning traffic. Positioned at a close proximity to AQUA, our shuttle service will offer stops to the ferry, making it a simple commute into the city."],
    image: neighborhoodFerry,
    imageAlt: 'Upcoming Ferry'
  },
  {
    title: "Hudson-Bergen Light Rail Access",
    content: ["45th Street Station – Just a 3-Minute Walk Away", "Located a mere 3-minute walk from 54 Flagship Street, the 45th Street Station on the Hudson-Bergen Light Rail offers residents seamless connectivity to key destinations across Hudson County and into Manhattan."],
    image: lightrail,
    imageAlt: 'Hudson-Bergen Light Rail Access'
  },
  {
    title: "Shuttle to Path Station",
    content: ["AQUA's weekday shuttle will offer direct service to the Grove St. PATH Station, making your daily commute simple and seamless."],
    image: shuttleBus,
    imageAlt: 'Shuttle to Path Station'
  },
  {
    title: "Stunning Waterfront Retreat",
    content: [
      "Step outside and unwind with breathtaking views along a pristine waterfront walkway. Whether you’re enjoying a morning jog or a peaceful evening stroll, the calm waters and picturesque scenery will become your personal sanctuary. The perfect blend of tranquility and beauty, this idyllic setting offers the luxury of nature, right at your feet."
    ],
    image: neighborhoodWaterfront,
    imageAlt: 'Neighborhood Waterfront Walkway'
  },
  {
    title: "A Culinary Journey at Your Doorstep",
    content: [
      "Experience the art of dining with an upscale food hall directly attached to your building, offering an array of gourmet options for every palate. From artisanal dishes to decadent treats, indulge in a world-class culinary experience without ever leaving the comfort of your home. The convenience and elegance of a fine dining experience, just an elevator ride away."
    ],
    image: neighborhoodFoodHall,
    imageAlt: 'Neighborhood Food Hall'
  },
  {
    title: "Luxury Meets Everyday Convenience",
    content: [
      "Enjoy unmatched convenience with Costco, Aldi, and Starbucks just a short walk from your front door, along with LA Fitness to help you stay energized and active. From everyday essentials to indulgent luxuries, everything you need is within easy reach. Whether you're hosting a dinner party or just running errands, this access to trusted brands adds a touch of practical luxury to your daily life."
    ],
    image: neighborhoodCostco,
    imageAlt: 'Neighborhood Costco'
  },
  {
    title: "A Golfer’s Paradise, Just Minutes Away",
    content: [
      "Enjoy stunning views of a world-class championship golf course right outside your door. The lush fairways and manicured greens provide a peaceful, picturesque backdrop that brings a sense of luxury and tranquility to everyday life."
    ],
    image: neighborhoodGolf,
    imageAlt: 'Neighborhood Golf Course'
  },
  {
    title: "Historic Landmarks",
    content: [
      "Situated nearby along Bayonne’s waterfront, the Tear Drop Memorial—officially titled To the Struggle Against World Terrorism—stands as a powerful and moving tribute. This 100-foot monument, gifted to the United States by Russia in 2006, honors the victims of the September 11 attacks and the 1993 World Trade Center bombing. A massive bronze teardrop suspended within a fractured tower symbolizes shared grief and global solidarity."
    ],
    image: tearDropMemorial,
    imageAlt: 'Historic Landmarks'
  }
];
